<template>
  <div id="content-lab-toast" data-testid="content-lab-toast" class="content-lab-root" />
</template>

<script>
import logger from '@goldcast/logger';
import { defineComponent } from 'vue';

import renderReactComponent from './renderReactComponent';

let unmount = null;
export default defineComponent({
  name: 'ContentLabToast',
  mounted() {
    import('content_studio/renderContentLabToast')
      .then(({ default: renderContentLabToast }) => {
        unmount = renderReactComponent(renderContentLabToast, 'content-lab-toast');
      })
      .catch(err => {
        logger.error('Failed importing content_studio/renderContentLabToast', err);
      });
  },
  unmounted() {
    if (unmount) {
      unmount();
    }
  }
});
</script>
